(() => {
  'use strict';
  const labels = JSON.parse(document.querySelector('[data-fr2-translations]')?.textContent || '{}');
  const readyForms = new WeakSet();
  const init = (scope = document) => {
    scope.querySelectorAll('[data-fr2-gallery]:not([data-fr2-ready])').forEach((gallery) => {
      gallery.dataset.fr2Ready = 'true';
      const track = gallery.querySelector('[data-fr2-gallery-track]');
      const slides = Array.from(track.querySelectorAll('[data-fr2-slide]'));
      const navigation = gallery.querySelector('[data-fr2-gallery-nav]');
      const previous = gallery.querySelector('[data-fr2-gallery-prev]');
      const next = gallery.querySelector('[data-fr2-gallery-next]');
      const count = gallery.querySelector('[data-fr2-gallery-count]');
      if (slides.length < 2) return;
      navigation.hidden = false;
      let index = 0;
      const update = () => {
        index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        count.textContent = `${index + 1} / ${slides.length}`;
        previous.disabled = index === 0;
        next.disabled = index === slides.length - 1;
      };
      const move = (direction) => {
        const target = Math.max(0, Math.min(slides.length - 1, index + direction));
        track.scrollTo({ left: target * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      update();
    });
    scope.querySelectorAll('.fr2-product-form').forEach((component) => {
      if (readyForms.has(component)) return;
      readyForms.add(component);
      component.dataset.fr2Ready = 'true';
      const info = component.closest('.fr2-product-info, .fr2-card__body') || component;
      const variantSelect = component.querySelector('[data-fr2-variant]');
      const quantity = component.querySelector('[name="quantity"]');
      const variantInput = component.querySelector('[name="id"]');
      if (!variantSelect) return;
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        const available = option.dataset.available === 'true';
        variantInput.value = option.value;
        variantInput.disabled = !available;
        quantity.disabled = !available;
        quantity.min = option.dataset.quantity || '1';
        quantity.step = option.dataset.increment || '1';
        if (option.dataset.maximum) quantity.max = option.dataset.maximum;
        else quantity.removeAttribute('max');
        if (quantity.type === 'hidden') quantity.value = quantity.min;
        const price = info.querySelector('[data-fr2-price]');
        if (price) price.textContent = option.dataset.price;
        const comparisonPrice = info.querySelector('[data-fr2-compare-price]');
        if (comparisonPrice) comparisonPrice.hidden = true;
        const stock = info.querySelector('[data-fr2-stock]');
        if (stock) {
          stock.textContent = available ? labels.available : labels.disabled;
          stock.classList.toggle('fr2-stock--unavailable', !available);
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
